import { Select, SwissSelect } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { EnrollmentStage } from 'types/enrollmentService';
import { useTriggerRenewalsPageStore } from 'store/pages/tools/trigger-renewals/pageStore';
import { getRenewalEffectiveDateOptions } from 'global/utils/renewalsEffectiveDates';
import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { RenewalDataFilter } from 'types/groupService';
import { RENEWAL_DATA_FILTER_OPTIONS } from '../constants';
import MoreDropdown from './MoreDropdown';
import { HeaderBlockStyled, InfoHeaderStyled } from './styles';

const stageOptions = [
  {
    value: EnrollmentStage.INSTALLED,
    label: 'Installed',
  },
  {
    value: EnrollmentStage.RENEWAL,
    label: 'Renewal',
  },
];

const FiltersPanel: React.FC = observer(() => {
  const { allSponsorAgencies, paginationDelegate } = useTriggerRenewalsPageStore();

  const onSetAgency = (value: string[]): void => {
    paginationDelegate.setFilterValue('agencyId', value[0] ?? '');
  };

  const onSetEffectiveDate = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    paginationDelegate.setFilterValue('effectiveDate', e.target.value);
  };

  const onSetStage = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    paginationDelegate.setFilterValue('stage', e.target.value as EnrollmentStage);
  };

  const onSetExhibitsFilter = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    paginationDelegate.setFilterValue('exhibitsFilter', e.target.value as RenewalDataFilter);
  };

  const onSetRatesFilter = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    paginationDelegate.setFilterValue('ratesFilter', e.target.value as RenewalDataFilter);
  };

  const agencyOptions: OptionType[] = [
    { label: 'All', value: '' },
    ...allSponsorAgencies.map((agency) => ({
      label: agency.name,
      value: agency.id,
    })),
  ];

  return (
    <InfoHeaderStyled>
      <HeaderBlockStyled>
        <SwissSelect
          id="agency"
          label="Agency"
          options={agencyOptions}
          value={paginationDelegate.filters.agencyId ? [paginationDelegate.filters.agencyId] : []}
          onChange={onSetAgency}
          placeholder="All agencies"
          withSearch
          searchPlaceholder="Agency name"
          width="23rem"
        />
        <Select
          label="Effective Date"
          name="effectiveDate"
          options={getRenewalEffectiveDateOptions()}
          onChange={onSetEffectiveDate}
          value={paginationDelegate.filters.effectiveDate}
          width="23rem"
          validationPassed={!!paginationDelegate.filters.effectiveDate}
          validationMessage="Please select effective date"
        />
        <Select
          label="Stage"
          name="stage"
          options={stageOptions}
          onChange={onSetStage}
          value={paginationDelegate.filters.stage}
          width="23rem"
        />
        <Select
          label="Exhibits"
          name="exhibitsFilter"
          options={RENEWAL_DATA_FILTER_OPTIONS}
          onChange={onSetExhibitsFilter}
          value={paginationDelegate.filters.exhibitsFilter}
          width="23rem"
        />
        <Select
          label="Rates"
          name="ratesFilter"
          options={RENEWAL_DATA_FILTER_OPTIONS}
          onChange={onSetRatesFilter}
          value={paginationDelegate.filters.ratesFilter}
          width="23rem"
        />
      </HeaderBlockStyled>
      <MoreDropdown />
    </InfoHeaderStyled>
  );
});

export default FiltersPanel;
